// Version : 0.0.3
// Author : VIGNESH
// LastEdit : VIGNESH
// Last ADD : REMOVED UNWANTED REDUX
// MODFIED DATA : 07-12-2025

import GoldLoanArrearReportTypes from './gold-loan-arrear-report.types';

/** ***************** FETCH GOLD PRICE DETAILS START *********************** */
export const fetchGoldLoanArrearReportStart = (fetchData: any) => ({
	type: GoldLoanArrearReportTypes.GET_GOLDLOAN_ARREAR_REPORT_START,
	payload: fetchData,
});

export const fetchGoldLoanArrearReportSuccess = (successData: any) => ({
	type: GoldLoanArrearReportTypes.GET_GOLDLOAN_ARREAR_REPORT_SUCCESS,
	payload: successData,
});

export const fetchGoldLoanArrearReportFailure = (failureData: any) => ({
	type: GoldLoanArrearReportTypes.GET_GOLDLOAN_ARREAR_REPORT_FAILURE,
	payload: failureData,
});

export const fetchGoldLoanArrearReportResponseReset = () => ({
	type: GoldLoanArrearReportTypes.GET_GOLDLOAN_ARREAR_REPORT_RESPONSE_RESET,
});

export const fetchGoldLoanArrearReportResponseChanged = () => ({
	type: GoldLoanArrearReportTypes.GET_GOLDLOAN_ARREAR_REPORT_RESPONSE_CHANGED,
});

/** ***************** FETCH GOLD PRICE DETAILS END *********************** */
